import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { colors } from '../theme';

// Filled circle with a white "!" — the border-based triangle approach
// renders as an opaque dark box in @react-pdf, so we use a circle instead.
// Visually unambiguous as a warning indicator at this size.
const WarningGlyph = ({ size = 18, color = colors.danger }) => (
  <View style={{
    width: size,
    height: size,
    borderRadius: size / 2,
    backgroundColor: color,
    alignItems: 'center',
    justifyContent: 'center',
  }}>
    <Text style={{
      color: '#ffffff',
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: size * 0.62,
      lineHeight: 1,
    }}>
      !
    </Text>
  </View>
);

export default WarningGlyph;
